import { render, staticRenderFns } from "./coachData.vue?vue&type=template&id=514bef16&scoped=true&"
import script from "./coachData.vue?vue&type=script&lang=js&"
export * from "./coachData.vue?vue&type=script&lang=js&"
import style0 from "./coachData.vue?vue&type=style&index=0&id=514bef16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514bef16",
  null
  
)

export default component.exports